<script>
import { cmsUrl } from '../variables';
import axios from 'axios';

import LoadIndicator from '../components/LoadIndicator';
import Offering from '../components/Offering';
import Project from '../components/Project';
import Event from '../components/Event';

export default {
    name: 'OrganisationOverview',
    components: {
        LoadIndicator,
        Offering,
        Project,
        Event,
    },
    data() {
        return {
            organizationData: null,
            isLoading: true,
        }
    },
    mounted() {
        this.init(this.$route.params.organisationId)
    },
    methods: {
        init(id) {
            axios
                .get(cmsUrl + '/organisations?id=' + id)
                .then(this.onDataLoaded)
                .catch(err => this.onError(err))
        },
        onDataLoaded(data) {
            if (!data || !data.data) {
                this.onError(data);
                return;
            }
            this.organizationData = data.data;
            this.isLoading = false;
        },
        onError() {
            this.isLoading = false;
            this.$router.push('/page-not-found');
            
        },
    },
    computed: {
        routerKey() {
            return this.$route.path;
        },
    },
};
</script>

<template>
    <section class="organisation-overview">
        <div v-if="!isLoading">
            <h1 class="organisation-overview__page-title">{{$t('organisationOverview.pageTitle')}}</h1>
            <h2 class="organisation-overview__organisation-title page-title" >{{ organizationData.organisation.post_title }}</h2>

            <section class="organisation-overview__offerings">
                <h1 class="organisation-overview__offerings__title">{{$t('organisationOverview.offeringSectionTitle')}}</h1>
                <p class="organisation-overview__offerings__lead">{{$t('organisationOverview.offeringSectionLead')}}</p>
                <div class="organisation-overview__list" >
                    <div class="organsiation-overview__list-actions">
                        <router-link v-bind:to="$route.params.organisationId + '/offering/add/'" class="organisation-overview__add-btn">{{$t('organisationOverview.offeringAddNew')}}</router-link>
                    </div>
                    <div class="organisation-overview__list__body">
                        <offering 
                            v-for="offering in organizationData.offers" 
                            v-bind:key="offering.ID"
                            v-bind:title="offering.post_title"
                            v-bind:description="offering.description"
                            v-bind:organisation="offering.organisation"
                            v-bind:link="offering.link"
                            v-bind:id="offering.ID"
                            v-bind:status="offering.post_status"
                            v-bind:editMode="true">
                        </offering>
                        <div class="organisation-overview__list-no-titem" v-if="organizationData.offers.length === 0">{{$t('organisationOverview.offeringNoItems')}}</div>
                    </div>
                    <div class="organsiation-overview__list-actions">
                        <router-link v-bind:to="$route.params.organisationId + '/offering/add/'" class="organisation-overview__add-btn">{{$t('organisationOverview.offeringAddNew')}}</router-link>
                    </div>
                </div>
            </section>

            <section class="organisation-overview__projects">
                <h1 class="organisation-overview__projects__title">{{$t('organisationOverview.projectSectionTitle')}}</h1>
                <p class="organisation-overview__projects__lead">{{$t('organisationOverview.projectSectionLead')}}</p>
                <div class="organisation-overview__list" >
                    <div class="organsiation-overview__list-actions">
                        <router-link v-bind:to="$route.params.organisationId + '/project/add/'" class="organisation-overview__add-btn">{{$t('organisationOverview.projectAddNew')}}</router-link>
                    </div>
                    <div class="organisation-overview__list__body">
                        <project 
                            v-for="project in organizationData.projects" 
                            v-bind:key="project.ID"
                            v-bind:title="project.post_title"
                            v-bind:description="project.description"
                            v-bind:organisation="project.organisation"
                            v-bind:link="project.link" 
                            v-bind:featured="project.featured"
                            v-bind:id="project.ID"
                            v-bind:status="project.post_status"
                            v-bind:editMode="true">
                        </project>

                        <div class="organisation-overview__list-no-titem" v-if="organizationData.projects.length === 0">{{$t('organisationOverview.projectNoItems')}}</div>
                    </div>
                    <div class="organsiation-overview__list-actions">
                        <router-link v-bind:to="$route.params.organisationId + '/project/add/'" class="organisation-overview__add-btn">{{$t('organisationOverview.projectAddNew')}}</router-link>
                    </div>
                </div>
            </section>

            <section class="organisation-overview__events">
                <h1 class="organisation-overview__events__title">{{$t('organisationOverview.eventSectionTitle')}}</h1>
                <p class="organisation-overview__events__lead">{{$t('organisationOverview.eventSectionLead')}}</p>
                <div class="organisation-overview__list" >
                    <div class="organsiation-overview__list-actions">
                        <router-link v-bind:to="$route.params.organisationId + '/event/add/'" class="organisation-overview__add-btn">{{$t('organisationOverview.eventAddNew')}}</router-link>
                    </div>
                    <div class="organisation-overview__list__body">
                        <event 
                            v-for="event in organizationData.events" 
                            v-bind:key="event.ID"
                            v-bind="event.dates"
                            v-bind:dates="event.dates"
                            v-bind:title="event.post_title"
                            v-bind:description="event.description"
                            v-bind:organisation="event.organisation"
                            v-bind:link="event.link" 
                            v-bind:featured="event.featured"
                            v-bind:id="event.ID"
                            v-bind:status="event.post_status"
                            v-bind:editMode="true">
                        </event>

                        <div class="organisation-overview__list-no-titem" v-if="organizationData.events.length === 0">{{$t('organisationOverview.eventNoItems')}}</div>
                    </div>
                    <div class="organsiation-overview__list-actions">
                        <router-link v-bind:to="$route.params.organisationId + '/event/add/'" class="organisation-overview__add-btn">{{$t('organisationOverview.eventAddNew')}}</router-link>
                    </div>
                </div>
            </section>

            <p class="organisation-overview__contact" v-html="$t('organisationOverview.contact')"></p>

        </div>
        <load-indicator v-if="isLoading" />
    </section>
</template>

<style lang="scss" scoped>
.organisation-overview__page-title {
    margin: 0 0 0.8rem;
    font-size: 1.8rem;
    font-weight: 300;
    color: #324155;
    letter-spacing: 0.1rem;
    text-transform: uppercase;
}
.organisation-overview__offerings__title,
.organisation-overview__projects__title,
.organisation-overview__events__title {
    font-size: 3.2rem;
    margin: 0;
}
.organisation-overview__offerings__lead,
.organisation-overview__projects__lead,
.organisation-overview__events__lead {
    max-width: 48rem;
    font-size: 1.8rem;
    line-height: 1.4444;
}

.organisation-overview__offerings,
.organisation-overview__projects,
.organisation-overview__events {
    margin: 3.2rem 0 11.2rem;
}
.organisation-overview__list {
    margin: 3.2rem 0;
}
.organisation-overview__list__body {
    margin: 1.6rem 0;
    border-top: 0.1rem solid rgba($color-primary, .15);
}
.organisation-overview__list-no-titem {
    text-align: center;
    border-bottom: 0.1rem solid rgba($color-primary, .15);
    padding: 0.8rem;
}

.organsiation-overview__list-actions {
    text-align: right;
}
.organisation-overview__add-btn {
    font-size: 1.6rem;
    color: $color-secondary-alt;
    letter-spacing: 0.046rem;
    text-decoration: none;
}
.organisation-overview__add-btn:after {
    content: "";
    display: inline-block;
    width: 2.4rem; height: 2.4rem;
    margin-left: 0.48rem;
    vertical-align: bottom;
    background: center no-repeat url('~@/assets/images/ico-add.svg');
}

.organisation-overview__contact {
    font-size: 1.92rem;
}
</style>
